export class ReferenceDocument
{
    filename :string;
    contentType :string;
    content:number[];
    createdDate:string;
    title:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/reference-document/entities/reference-document.ts